function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect } from 'react';
import { deDupe, emptyArray, ensureArray, isArray, isFunction } from '@okee-uikit/react-utils';
import { useConstCallback, useRefCallback } from '../callback';
import { useConst, usePrevious } from '../state';
import { useControllable } from './controllable';
export function useActive() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var value = options.value,
      _options$defaultValue = options.defaultValue,
      _defaultValue = _options$defaultValue === void 0 ? value : _options$defaultValue,
      onChange = options.onChange,
      controlled = options.controlled,
      _options$exclusive = options.exclusive,
      exclusive = _options$exclusive === void 0 ? false : _options$exclusive;

  var fallbackValue = useConst(emptyArray);

  var _useControllable = useControllable({
    value: value && exclusive && value.length > 1 && [value[0]] || value,
    defaultValue: function defaultValue() {
      var initialValue = isFunction(_defaultValue) ? _defaultValue() : _defaultValue;

      if (!isArray(initialValue)) {
        return fallbackValue;
      }

      if (exclusive && initialValue.length > 1) {
        return [initialValue[0]];
      }

      return deDupe(initialValue);
    },
    onChange: onChange,
    controlled: controlled
  }),
      _useControllable2 = _slicedToArray(_useControllable, 2),
      innerValue = _useControllable2[0],
      setInnerValue = _useControllable2[1];

  var currentValue = isArray(innerValue) && innerValue || fallbackValue;
  var previousExclusive = usePrevious(exclusive);
  useEffect(function () {
    if (exclusive && exclusive !== previousExclusive && currentValue.length > 1) {
      setInnerValue([currentValue[0]]);
    }
  }, [exclusive]);
  var setActive = useRefCallback(function (update, event) {
    setInnerValue(function (pre) {
      var newValue = isFunction(update) ? update(pre || fallbackValue) : update;

      if (!isArray(newValue)) {
        return fallbackValue;
      }

      if (exclusive && newValue.length > 1) {
        return [newValue[0]];
      }

      return deDupe(newValue);
    }, event);
  });
  var activate = useConstCallback(function (items, event) {
    var finalItems = ensureArray(items);
    setActive(function (pre) {
      return finalItems.length === 0 && pre || [].concat(_toConsumableArray(finalItems), _toConsumableArray(pre));
    }, event);
  });
  var inactivate = useConstCallback(function (items, event) {
    var finalItems = ensureArray(items);
    setActive(function (pre) {
      return finalItems.length === 0 && pre || pre.filter(function (preItem) {
        return !finalItems.includes(preItem);
      });
    }, event);
  });
  var toggle = useConstCallback(function (items, event) {
    var finalItems = ensureArray(items);
    setActive(function (pre) {
      if (finalItems.length === 0) {
        return pre;
      }

      var toActive = finalItems.filter(function (item) {
        return !pre.includes(item);
      });
      var toReserve = pre.filter(function (preItem) {
        return !finalItems.includes(preItem);
      });
      return [].concat(_toConsumableArray(toActive), _toConsumableArray(toReserve));
    }, event);
  });
  var isActive = useRefCallback(function (item) {
    return currentValue.includes(item);
  });
  var actions = useConst({
    setActive: setActive,
    activate: activate,
    inactivate: inactivate,
    toggle: toggle,
    isActive: isActive,
    exclusive: exclusive
  });
  actions.exclusive = exclusive;
  return [currentValue, actions];
}